export default {
  serviceUnavailable: 'Service unavailable :(',
  tryAgain: 'Try again or contact your HR manager.',
  serverUnavailable: 'Server unavailable',
};
